import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_DataFile() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  const uploadFile = async (
    affiliate,
    event_id,
    data_source,
    data,
    onUploadProgress
  ) => {
    const { headers, queryString } = await queryParamsAndHeaders(
      { affiliate, event_id, data_source },
      null,
      true
    );

    const formData = new FormData();
    formData.append("file", data.file, data.file.name);

    return apiCall({
      url: `${backendUrl}/api/event/uploads?${queryString}`,
      method: "POST",
      data: formData,
      headers,
      onUploadProgress,
    });
  };

  return {
    uploadFile,
  };
}
